import React, { useEffect, useState } from "react";
import AddButton from "../../../components/admin/usable/AddButton";
import { useNavigate } from "react-router";
import Pagination from "@mui/material/Pagination";
import { blogList, deleteBlog } from "../../../api/admin/blogApi";
import TableLoader from "../../../components/admin/usable/TableLoader";
import EditButton from "../../../components/admin/usable/actions/EditButton";
import DeleteButton from "../../../components/admin/usable/actions/DeleteButton";

const ViewBlogList = () => {
  const navigate = useNavigate();
  const [BlogData, setBlogData] = useState([]);
  const [PaginationData, setPaginationData] = useState("");
  const [Page, setPage] = useState(1);
  const [Limit, setLimit] = useState(10);
  const handleAddNewPost = () => {
    navigate("/admin/blog/create");
  };
  useEffect(() => {
    blogList(setBlogData, setPaginationData, Page, Limit);
  }, [Page, Limit]);
  const handleShowmore = (e) => {
    setPage((prev) => prev + 1);
  };
  const handleDelete = (item) => {
    const id = item.id;
    deleteBlog(setBlogData, setPaginationData, Page, Limit, id);
  };
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <p className="font-bold">Blog List</p>
        <AddButton onClick={handleAddNewPost} text="Add New Post" />
      </div>
      <div className="w-full overflow-x-auto bg-white rounded-lg drop-shadow-md">
        <table className="min-w-full border border-gray-200 bg-white rounded-lg overflow-hidden">
          <thead className="bg-gray-100">
            <tr>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                ID
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Cover
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Blog Title
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Category
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Created By
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Status
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                CreatedAt
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Action
              </th>
            </tr>
          </thead>

          <tbody className="divide-y divide-gray-200">
            {BlogData.length > 0 ? (
              <>
                {BlogData.map((item, index) => {
                  return (
                    <tr key={index} className="hover:bg-gray-50">
                      <td className="px-4 py-3 text-sm text-gray-700">
                        {index + 1}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700">
                        <div className="w-20 h-12 overflow-hidden rounded-lg">
                          <img
                            className="w-full h-full object-cover"
                            src={item.featuredImage}
                            alt=""
                          />
                        </div>
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                        <a href="#" target="_blank" rel="noopener noreferrer">
                          {" "}
                          {item.blogTitle}
                        </a>
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700">
                        <span className="px-2 py-1 bg-blue-100 text-blue-700 rounded text-xs">
                          {item.category_name}
                        </span>
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700">
                        {item.created_by_name}
                      </td>
                      <td className="px-4 py-3 text-sm">
                        <span
                          className={`px-2 py-1 ${
                            item.status === "Published"
                              ? "bg-green-100 text-green-700"
                              : "bg-red-100 text-red-700"
                          } rounded text-xs`}
                        >
                          {item.status}
                        </span>
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700">
                        {item.createdAt.slice(0, 10)}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700 flex gap-x-2">
                        <EditButton
                          onClick={() =>
                            navigate(`/admin/blog/edit/${item.id}`)
                          }
                        />{" "}
                        <DeleteButton onClick={() => handleDelete(item)} />
                      </td>
                    </tr>
                  );
                })}
              </>
            ) : (
              <TableLoader colSpan={8} />
            )}
          </tbody>
        </table>
      </div>
      <div className="flex justify-between items-center">
        <div>
          <p>
            Showing {BlogData.length} of {PaginationData} entries
          </p>
        </div>
        <div>
          <Pagination
            onChange={handleShowmore}
            count={PaginationData}
            variant="outlined"
          />
        </div>
      </div>
    </div>
  );
};

export default ViewBlogList;
